import { CssUnitValue, Shadow } from '../../adapters/types';
import { TranslationKeys as _TranslationKeys } from '../translationKeys';

export enum AlignmentOptions {
  right = 'right',
  center = 'center',
  left = 'left',
  justify = 'justify',
}

export const TranslationKeys = _TranslationKeys.section.text;
export enum TextTransformOptions {
  lowercase = 'lowercase',
  uppercase = 'uppercase',
  none = 'none',
}
export enum LineHeightMode {
  Custom = 'Custom',
  Automatic = 'Automatic',
}
export const DEFAULT_CUSTOM_LINE_HEIGHT = {
  type: 'CssUnitValue',
  unit: 'em',
  value: 1.2,
} as CssUnitValue;

export const AUTO_LINE_HEIGHT = { type: 'CssValue', value: 'unset' };

export const DataHooks = {
  theme: 'theme',
  font: 'font',
  fontSize: 'font-size',
  textBold: 'text-bold',
  textItalic: 'text-italic',
  textUnderline: 'text-underline',
  textStrikethrough: 'text-strikethrough',
  capitalization: 'capitalization',
  textColor: 'text-color',
  outlineColor: 'outline-color',
  highlightColor: 'highlight-color',
  textDirection: 'text-direction',
  textAlign: 'text-align',
  letterSpacing: 'letter-spacing',
  lineHeightMode: 'line-height-mode',
  lineHeight: 'line-height',
  shadowMode: 'shadow-mode',
  shadowAngle: 'shadow-angle',
  shadowColor: 'shadow-color',
  shadowOpacity: 'shadow-opacity',
  shadowDistance: 'shadow-distance',
  shadowBlur: 'shadow-blur',
  shadowSize: 'shadow-size',
};

export const CHARACTER_SPACING_SLIDER_CONFIG = {
  min: -0.1,
  max: 0.7,
  step: 0.05,
} as const;

export const LINE_HEIGHT_SLIDER_CONFIG = {
  min: 0.5,
  max: 3,
  step: 0.02,
} as const;

export const CUSTOM_THEME_FONT = {
  value: 'custom',
  label: TranslationKeys.fontThemeSelector.customOption,
} as const;

export const COLOR_TRANSPARENT = 'transparent';

export const DEFAULT_SHADOW = {
  type: 'TextShadow',
  inset: false,
  angle: 0,
  distance: {
    type: 'CssUnitValue',
    value: 0,
    unit: 'px',
  },
  blur: {
    type: 'CssUnitValue',
    value: 0,
    unit: 'px',
  },
  color: {
    type: 'Color',
    red: 0,
    green: 0,
    blue: 0,
    alpha: 0,
  },
} as Shadow;
